// Fecha LOCAL (YYYY-MM-DD), no UTC: `toISOString()` adelanta el día entre 18:00 y 23:59 en México (UTC-6).
export const localTodayIso = (now = new Date()) => now.toLocaleDateString('en-CA');
